import React, { useEffect } from 'react';
import { auth } from '../../firebase/firebase-config';
import { markBenefitAsRead } from '../../services/benefitsService';
import ContentAttachmentsActions from '../../platform/ContentAttachmentsActions';
import ContentDetailHero from '../../platform/ContentDetailHero';
import ContentUnitTag from '../common/ContentUnitTag';
import {
  isDetailHeroEnabled,
  PREMIUM_MODULE_IDS,
  premiumDetailClassName,
} from '../../platform/contentListVisual';

function formatDate(date) {
  if (!date) return '';
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleString('sl-SI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function BenefitDetail({ benefit }) {
  const useHero = isDetailHeroEnabled(PREMIUM_MODULE_IDS.BENEFITS);

  useEffect(() => {
    const markAsRead = async () => {
      if (!auth.currentUser?.uid) return;
      await markBenefitAsRead(auth.currentUser.uid, benefit.id);
    };

    markAsRead();
  }, [benefit.id]);

  const meta = (
    <>
      <span>Ustvaril {benefit.displayName || 'Anonimen'}</span>
      {benefit.createdAt && (
        <>
          <span className="platform-content-detail-hero__meta-separator">·</span>
          <span>{formatDate(benefit.createdAt)}</span>
        </>
      )}
    </>
  );

  return (
    <article className={premiumDetailClassName(PREMIUM_MODULE_IDS.BENEFITS, 'benefit-detail platform-content-detail')}>
      <div className="platform-content-detail-shell">
        {useHero ? (
          <ContentDetailHero
            title={benefit.title}
            imageUrl={benefit.thumbnailUrl}
            badges={<ContentUnitTag item={benefit} />}
            meta={meta}
          />
        ) : null}

        <div className="platform-content-detail-card">
          {!useHero && (
            <div className="platform-content-detail-card__header">
              <h2 className="platform-content-detail-card__title">O ugodnosti</h2>
            </div>
          )}

          <div className="platform-content-detail__body">
            {!useHero && (
              <div className="platform-content-detail__meta">
                <ContentUnitTag item={benefit} />
                <span className="platform-content-detail__meta-separator">·</span>
                <span>Ustvaril {benefit.displayName || 'Anonimen'}</span>
                {benefit.createdAt && (
                  <>
                    <span className="platform-content-detail__meta-separator">·</span>
                    <span>{formatDate(benefit.createdAt)}</span>
                  </>
                )}
              </div>
            )}

            <div
              className="platform-content-detail__content"
              dangerouslySetInnerHTML={{ __html: benefit.text }}
            />

            <ContentAttachmentsActions item={benefit} className="platform-content-detail__actions" />
          </div>
        </div>

        {!useHero && benefit.thumbnailUrl && (
          <div className="platform-content-detail-card">
            <div className="platform-content-detail-card__header">
              <h2 className="platform-content-detail-card__title">Slika</h2>
            </div>
            <div className="platform-content-detail__media platform-content-detail__media--bottom">
              <img src={benefit.thumbnailUrl} alt="" loading="lazy" />
            </div>
          </div>
        )}
      </div>
    </article>
  );
}

export default BenefitDetail;
